import React, {useContext} from 'react';
import config from '../../config.js';
import UserContext from './UserContext.js';

import {useHistory, useLocation} from 'react-router-dom';

// css
import '../../assets/css/App.css';

// kendo react
import {Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import {Button} from "@progress/kendo-react-buttons";

// multilingual
import {Text} from './MultilingualText.js';
import {
    sessionExpiredKey,
    mainMessages,
    refreshKey
} from '../../assets/text/MultilingualText.js';
import {ClockIcon} from "./icons";

function Expired() {
    const {siteLanguageDefault} = useContext(UserContext);
    const expiredStyle = {
        display: "flex",
        verticalAlign: "middle",
        textAlign: "center"
    };


    let location = useLocation();
    const history = useHistory();

    const refresh = () => {
        if (location.pathname === '/trial-license') {
            let prodNum = new URLSearchParams(window.location.search).get("ProdNum");
            window.location.href = config.LEGACY_ASM + "TrialLicense.aspx?ProdNum=" + prodNum;
        } else {
            history.go(0);
        }
    }

    return (
        <Dialog width={'21rem'}>
            <div style={{
                display: "flex",
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem'
            }}>
                <div>
                    <ClockIcon size={'xxxlarge'}/>
                </div>
                <h2 style={{margin: 0}}>
                    <Text
                        textkey={sessionExpiredKey}
                        textdefault={mainMessages[siteLanguageDefault][sessionExpiredKey]}
                    />
                </h2>
            </div>
            <DialogActionsBar>
                <Button
                    themeColor={"primary"}
                    size={"large"}
                    shape={"rectangle"}
                    fillMode={"solid"}
                    rounded={"small"}
                    type={"button"}
                    onClick={refresh}
                    className={"k-button"}
                >
                    <Text
                        textkey={refreshKey}
                        textdefault={mainMessages[siteLanguageDefault][refreshKey]}
                    />
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
}

export default Expired;